import { combineReducers } from "redux";
import { reducer as form } from "redux-form";

import * as features from "../reducer";

export const rootReducer = combineReducers({
  ...features,
  form,
});
